import * as Yup from 'yup';
import uuid from 'uuid';
import { IGroundWaterZone } from './groundWaterZone';
import { IGroundWaterZoneFormValues } from './groundWaterZoneFormValues';
import { IGroundWaterZoneUpsert } from './groundWaterZoneUpsert';

export default class GroundWaterZoneModelHelper {
    public static createFormValues = (currency ?: IGroundWaterZone | null) : IGroundWaterZoneFormValues => {
        if (!currency) return {
            id: 0,
            guid: uuid.v4(),
            code: '',
            name: '',
            isActive: true,
        };

        return {
            id: currency.id,
            guid: currency.guid,
            code: currency.code,
            name: currency.name,
            isActive: currency.isActive,
        };
    };

    public static createUpsert = (currencyFormValues : IGroundWaterZoneFormValues) : IGroundWaterZoneUpsert => {
        return {
            id: currencyFormValues.id,
            guid: currencyFormValues.guid,
            code: currencyFormValues.code,
            name: currencyFormValues.name,
            isActive: currencyFormValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IGroundWaterZoneFormValues> => Yup.object({
        id: Yup.number().required('Required'),
        guid: Yup.string().required('Required'),

        code: Yup.string().required('Required'),
        name: Yup.string().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
